<template>
    <div>
        <HeaderMenu></HeaderMenu>
        <section class="bread_crumb">
            <div class="container">
                <ul>
                    <li>
                        <router-link class="nav-link" v-bind:to="'/'">{{ $t("Header.Home") }}</router-link>
                    </li>
                    <li>Checkout</li>
                </ul>
            </div>
        </section>
        <section class="inner_wrap checkout_page">
            <div class="container">   
                <h2>Checkout</h2>
                <div class="row checkout_wrapper">
                    <div class="col-md-6">
                        <div class="step-two">
                            <form class="row">
                                <h3>Payment Information</h3>
                                <div class="form-group col-md-12">
                                    <input class="form-control" name="name" v-model="name" placeholder="Name on Card*">
                                    <div class="error" id="name_error"></div>
                                </div>
                                <div class="form-group  col-md-12">
                                    <input class="form-control" name="number" v-model="number" placeholder="Card Number*">
                                    <div class="error" id="number_error"></div>
                                    <div class="error" id="company_error"></div>
                                </div>
                                <div class="form-group  col-md-4">
                                    <input class="form-control" name="month" v-model="month" placeholder="Expiry Month*">
                                    <div class="error" id="month_error"></div>
                                </div>
                                <div class="form-group  col-md-4">
                                    <input class="form-control" name="year" v-model="year" placeholder="Expiry Year*">
                                    <div class="error" id="year_error"></div>
                                </div>
                                <div class="form-group col-md-4">
                                    <input class="form-control" name="cvc" v-model="cvc" placeholder="CVC Number*">
                                    <div class="error" id="cvc_error"></div>
                                </div>
                                <div class="form-group  col-md-12">
                                    <button type="button" class="btn btn-primary" v-if="payment_button_loading==false" v-on:click="checkout">Submit</button>
                                    <button type="button" class="btn btn-primary" v-if="payment_button_loading==true">Processing...</button>
                                </div>
                                <div class="form-group  col-md-12">
                                    <div class="error" id="payment_error"></div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <h3>Order Review</h3>
                        <div class="order-box">
                            <div class=""  v-if="listing != null">   
                                <table class="cart-table">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <div class="item-pic">
                                                    <img :src="hostname+'/admin/images/course_images/'+listing.image" :alt="listing.name_eng">
                                                </div>
                                            </td>
                                            <td>
                                                <router-link class="nav-link"   v-bind:to="'/courses/'+listing.slug">
                                                    {{listing.name_eng}}
                                                </router-link>
                                                <div class="cart-total">
                                                    <ul>
                                                        <li>
                                                            <span>Sub Total:</span>
                                                            <b>SAR {{ listing.amount }}</b>
                                                        </li>
                                                        <li>
                                                            <span>Tax:</span>
                                                            <b>SAR {{ total_tax }}</b>
                                                        </li>
                                                        <li>
                                                            <span>Total:</span>
                                                            <b>SAR {{ total_amount }}</b>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
var final_amount = 0;
import axios from 'axios'
import HeaderMenu from '../HeaderMenu'
import router from '../../router'
export default{
    data() {
        
        return {
            hostname:this.$hostname,
            errors:[],
            tax:15,
            name:'',
            number:'',
            month:'',
            year:'',
            cvc:'',
            tax_value:0,
            payment_button_loading:false,
            listing:null,
            course_error:''
        }
    },
    components:{
        HeaderMenu:HeaderMenu
    },
    mounted(){
        if(this.$store.state.auth.current_user==null){
            router.push({ name: 'Login' });
        }
        if(!this.$route.params.slug){
            router.push({ name: 'Home' });
        }
        this.get_course();
    },
    methods: {
        async get_course() {
            var _self = this;
            await this.$axios_global.post(_self.$hostname+'/api/course-details',{
              slug:_self.$route.params.slug
            })
            .then((res) => {
                var response = res.data.data;
                _self.listing = response;
                return true;
            })
            .catch((error) => {
                if(error.response.data.status=="empty"){
                    _self.course_error = "Course doesn't exists."
                }
                return false;
            })
            return false;
        },
        async get_tax_percentage() {
            var _self = this; 
            await this.$axios_global.post(_self.$hostname+'/api/get-tax-percentage')
            .then((res) => {
                var response = res.data.tax;
                this.tax = parseFloat(response);
            })
            .catch((error) => {
                return false;  
            }) 
            return false; 
        },
        submit_billing_address(){
            var _self = this;
            console.log("Validate Billing Address");
            axios.post(this.$hostname+'/api/validate-billing-address',{
                first_name:_self.first_name,
                last_name:_self.last_name,
                phone:_self.phone,
                address_1:_self.address_1,
                address_2:_self.address_2,
                state:_self.state,
                city:_self.city,
                zipcode:_self.zipcode
            })
            .then((res) => {
                 _self.step_one_active = false;
                _self.step_two_active = true;
                _self.errors = [];
                // router.push({name: 'Login',query: { success: true }})
            })
            .catch((error) => {
                this.errors = error.response.data;
                return false;
            })
        },
        async checkout(){
            var _self = this;
            var errors = [];
            $('.step-two .error').html("");
            if(_self.name==""){
                errors.push({
                    key : 'name',
                    value : 'This field is required'
                });
            }
            if(_self.number==""){
                errors.push({
                    key : 'number',
                    value : 'This field is required'
                });
            }
            if(_self.cvc==""){
                errors.push({
                    key : 'cvc',
                    value : 'This field is required'
                });
            }
            if(_self.month==""){
                errors.push({
                    key : 'month',
                    value : 'This field is required'
                });
            }
            if(_self.year==""){
                errors.push({
                    key : 'year',
                    value : 'This field is required'
                });
            }
            if(errors.length){
                errors.forEach(function(ob){
                    $('#'+ob.key+'_error').html('<span>'+ob.value+'<span>');
                })
                return false;
            }

            
            _self.payment_button_loading = true;
            await this.$axios_global.post("https://api.moyasar.com/v1/payments",{
                amount:parseInt(parseFloat(_self.total_amount) * 100),
                source:{
                    type:"creditcard",
                    name:_self.name,
                    number:_self.number,
                    cvc:_self.cvc,
                    month:_self.month,
                    year:_self.year,
                    // "3ds":false
                },
                // publishable_api_key:"pk_test_mfHQXjEmMjPxNVRKbhEWDhK4cZUHSKujGkY8HEhv",
                publishable_api_key:"pk_live_Uzad5cBd88Yzhn5auGJ932TuSRg3XCYkg2eLkXsm",
                callback_url:_self.$vue_hostname+"/order-response/",
                metadata:""
            })
            .then((response) => {
                console.log(response.data,"moyasar response");
                _self.process_payment(response.data);
            })
            .catch((error) => {
                console.log(error.response,"moyasar error response");  
                _self.payment_button_loading = false;
                var errors = error.response.data.errors;
                if(error.response.data.type=="invalid_request_error"){
                    $('#payment_error').html('<span>'+ error.response.data.message +'</span>');
                }
                console.log(errors,"errors length");
                $.each(errors, function(key,val){
                    console.log(key,val,"key + val");
                    $('#'+key+'_error').html('<span>'+val[0]+'<span>');
                });

                return false;  
            }) 
        },
        async process_payment(payment_response){
            var _self = this;

            await this.$axios_global.post(_self.$hostname+'/api/process-payment',{
                user_id:_self.$store.state.auth.current_user.id,
                sub_total:_self.listing.amount,
                tax:_self.tax_value,
                total:_self.total_amount,
                course_id:_self.listing.id,
                payment_response:payment_response
            })
            .then((response) => {
                console.log(response.data,"process_payment response");
                _self.payment_button_loading = false;
                // this.$store.commit('empty_cart');
                window.location.href = payment_response.source.transaction_url;
            })
            .catch((error) => {
                console.log(error,"process_payment catch error");
                console.log(error.response,"process_payment catch error.response");
                return false;  
            }) 
        }
    },
    computed: {
        total_tax() {
            var tax = (this.listing.amount * (this.tax/100)).toFixed(2);
            this.tax_value = tax;
            this.total_amount = (parseFloat(this.listing.amount) + parseFloat(tax)).toFixed(2);
            final_amount = this.total_amount;
            return tax;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Checkout/Checkout.vue